import React, { Fragment, MouseEventHandler, ReactElement, useState } from "react";
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";



export default function ConfirmDialog(props: {
  CustomButton: ({onClick}: {onClick: MouseEventHandler}) => ReactElement<any,any>;
  title: string;
  confirmText: string;
  active?: boolean;
  onAccept: Function;
}) {
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      <props.CustomButton onClick={() => props.active !== false ? setOpen(true) : props.onAccept()} />
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Abbrechen</Button>
          <Button
            variant="contained"
            onClick={() => {
              props.onAccept();
              setOpen(false);
            }}
            autoFocus
          >
            {props.confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
